import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Toast.module.css';

const Toast = ({ message, type = "error", duration = 5000, onClose }) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            if (onClose) onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return createPortal(
        <div className={`${styles.toast} ${styles.show} ${styles[type]}`}>
            {message}
        </div>,
        document.body
    );
};

export default Toast;
